export const nombresCiclos = (ciclo) => {
    switch(ciclo){
      case "inicial": return "Inicial";
      case "primerCiclo": return "Primer Ciclo";
      case "segundoCiclo": return "Segundo Ciclo";
      case "tercerCiclo": return "Tercer Ciclo";
      case "secundario": return "Secundario";
      default: return ciclo;
    }
  }